import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePageTitle } from '../hooks/usePageTitle'
import useLang from '../hooks/useLang'
import '../pages/Home.css'

// Импорты изображений
import logoQaraa from '../images/logo-qaraa.webp'
import qaraaCrmLogo from '../images/qaraaxqaraa-crm.webp'

export default function Terms() {
  const { lang, changeLang, t, languages } = useLang()
  usePageTitle(t.termsPageTitle)
  const navigate = useNavigate()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [langDropdownOpen, setLangDropdownOpen] = useState(false)
  const langRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) {
        setLangDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div style={{ minHeight: '100vh', background: '#FFFFFF' }}>
      {/* Fixed Header */}
      <header style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        background: 'rgba(255, 255, 255, 0.72)',
        backdropFilter: 'saturate(180%) blur(20px)',
        WebkitBackdropFilter: 'saturate(180%) blur(20px)',
        transition: 'all 0.3s ease'
      }}>
        <div className="home-header-container" style={{
          maxWidth: '1440px', margin: '0 auto', padding: '20px 48px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <div className="home-logo-container" style={{
            display: 'flex', alignItems: 'center', gap: '14px',
            cursor: 'pointer', transition: 'opacity 0.3s ease', opacity: 1
          }}
            onClick={() => navigate('/')}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            <img src={logoQaraa} alt="qaraa" className="home-logo"
              style={{ height: '42px', width: 'auto', transition: 'transform 0.3s ease' }} />
            <div>
              <div className="home-logo-title" style={{
                fontSize: '17px', fontWeight: '600', color: '#1C1C1E', lineHeight: '1.2'
              }}>
                <span className="logo-title-line1">qaraa.asia</span>
                <br className="mobile-break" />
                <span className="logo-title-line2 mobile-only-subtitle" style={{ fontSize: '12px', color: '#8E8E93', fontWeight: '500' }}>{t.logoSubtitle}</span>
              </div>
              <div className="home-logo-subtitle desktop-only-subtitle" style={{
                fontSize: '12px', color: '#8E8E93', marginTop: '4px'
              }}>
                {t.logoSubtitle}
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {/* Language Switcher */}
            <div ref={langRef} style={{ position: 'relative', marginRight: '6px' }}>
              <button
                onClick={() => setLangDropdownOpen(!langDropdownOpen)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  padding: '8px 14px',
                  background: langDropdownOpen ? 'rgba(0,0,0,0.06)' : 'transparent',
                  border: 'none', borderRadius: '100px', fontSize: '14px',
                  fontWeight: '500', color: '#8E8E93', cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
                }}
                onMouseEnter={(e) => { if (!langDropdownOpen) e.currentTarget.style.background = 'rgba(0,0,0,0.04)' }}
                onMouseLeave={(e) => { if (!langDropdownOpen) e.currentTarget.style.background = 'transparent' }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="2" y1="12" x2="22" y2="12"/>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                </svg>
                <span className="lang-text-label">{t.languageLabel}</span>
                <svg className="lang-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: langDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}>
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              {langDropdownOpen && (
                <div style={{
                  position: 'absolute', top: 'calc(100% + 8px)', right: 0,
                  background: '#FFFFFF', borderRadius: '12px',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)', padding: '6px',
                  minWidth: '140px', zIndex: 200
                }}>
                  {languages.map((l) => (
                    <button key={l.code}
                      onClick={() => { changeLang(l.code); setLangDropdownOpen(false) }}
                      style={{
                        display: 'block', width: '100%', padding: '10px 14px',
                        background: lang === l.code ? 'rgba(0,122,255,0.08)' : 'transparent',
                        border: 'none', borderRadius: '8px', fontSize: '14px',
                        fontWeight: lang === l.code ? '600' : '400',
                        color: lang === l.code ? '#007AFF' : '#1C1C1E',
                        cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s ease',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
                      }}
                      onMouseEnter={(e) => { if (lang !== l.code) e.currentTarget.style.background = 'rgba(0,0,0,0.04)' }}
                      onMouseLeave={(e) => { if (lang !== l.code) e.currentTarget.style.background = 'transparent' }}
                    >{l.label}</button>
                  ))}
                </div>
              )}
            </div>
            <button onClick={() => navigate('/login')} className="home-header-button-login" style={{
              padding: '10px 22px', background: 'transparent', border: 'none',
              borderRadius: '100px', fontSize: '15px', fontWeight: '600', color: '#000000',
              cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative', letterSpacing: '-0.3px',
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
            }}
              onMouseEnter={(e) => { e.target.style.background = 'rgba(0, 0, 0, 0.06)'; e.target.style.transform = 'scale(1.02)' }}
              onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.transform = 'scale(1)' }}
            >
              {t.login}
            </button>
            <button onClick={() => navigate('/login?mode=register')} className="home-header-button-register" style={{
              padding: '10px 22px', background: '#FFFFFF', border: '1.5px solid #007AFF',
              borderRadius: '100px', fontSize: '15px', fontWeight: '600', color: '#007AFF',
              cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
              letterSpacing: '-0.3px',
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
            }}
              onMouseEnter={(e) => { e.target.style.background = '#007AFF'; e.target.style.color = '#FFFFFF'; e.target.style.transform = 'scale(1.02)' }}
              onMouseLeave={(e) => { e.target.style.background = '#FFFFFF'; e.target.style.color = '#007AFF'; e.target.style.transform = 'scale(1)' }}
            >
              {t.register}
            </button>

            {/* Мобильное меню - три полоски */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="home-mobile-menu-button" style={{
              display: 'none', padding: '8px', background: 'transparent', border: 'none',
              cursor: 'pointer', flexDirection: 'column', gap: '5px'
            }}>
              <span style={{ width: '24px', height: '2px', background: '#000000', borderRadius: '2px', transition: 'all 0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translateY(7px)' : 'none' }}></span>
              <span style={{ width: '24px', height: '2px', background: '#000000', borderRadius: '2px', transition: 'all 0.3s', opacity: mobileMenuOpen ? 0 : 1 }}></span>
              <span style={{ width: '24px', height: '2px', background: '#000000', borderRadius: '2px', transition: 'all 0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none' }}></span>
            </button>
          </div>
        </div>
      </header>

      {/* Мобильное выпадающее меню */}
      {mobileMenuOpen && (
        <div className="home-mobile-menu" style={{
          position: 'fixed', top: '76px', left: 0, right: 0,
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'saturate(180%) blur(20px)',
          WebkitBackdropFilter: 'saturate(180%) blur(20px)',
          borderBottom: 'none', padding: '16px 20px', zIndex: 99,
          display: 'none', flexDirection: 'column', gap: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
        }}>
          <button onClick={() => { navigate('/login'); setMobileMenuOpen(false) }} style={{
            padding: '12px 20px', background: 'rgba(0, 0, 0, 0.06)', border: 'none',
            borderRadius: '12px', fontSize: '15px', fontWeight: '600', color: '#000000',
            cursor: 'pointer', width: '100%', letterSpacing: '-0.3px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
            transition: 'all 0.2s ease'
          }}>
            {t.login}
          </button>
          <button onClick={() => { navigate('/login?mode=register'); setMobileMenuOpen(false) }} style={{
            padding: '12px 20px', background: 'linear-gradient(180deg, #007AFF 0%, #0051D5 100%)',
            border: 'none', borderRadius: '12px', fontSize: '15px', fontWeight: '600',
            color: '#FFFFFF', cursor: 'pointer', width: '100%', letterSpacing: '-0.3px',
            boxShadow: '0 2px 8px rgba(0, 122, 255, 0.25)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
            transition: 'all 0.2s ease'
          }}>
            {t.register}
          </button>
        </div>
      )}

      {/* Content */}
      <section className="privacy-content-section" style={{
        paddingTop: '100px', paddingBottom: '120px', background: '#FFFFFF'
      }}>
        <div className="privacy-content-container" style={{
          maxWidth: '900px', margin: '0 auto', padding: '0 48px'
        }}>
          <h1 style={{
            fontSize: '64px', fontWeight: '600', lineHeight: '1.1', marginBottom: '16px',
            color: '#000000', letterSpacing: '-2px'
          }}>
            {t.termsTitle}
          </h1>

          <p style={{ fontSize: '16px', color: '#999999', marginBottom: '64px' }}>
            {t.termsLastUpdate}
          </p>

          <div style={{
            fontSize: '18px', color: '#000000', lineHeight: '1.8',
            display: 'flex', flexDirection: 'column', gap: '48px'
          }}>
            {t.termsSections.map((section, i) => (
              <section key={i}>
                <h2 style={{
                  fontSize: '32px', fontWeight: '600', marginBottom: '16px', letterSpacing: '-0.5px'
                }}>
                  {section.title}
                </h2>
                {section.body.includes('<') ? (
                  <div dangerouslySetInnerHTML={{ __html: section.body }} />
                ) : (
                  <p style={{ color: '#666666' }}>{section.body}</p>
                )}
              </section>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '80px 24px 50px',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        color: '#1C1C1E', position: 'relative',
        borderRadius: '60px 60px 0 0', marginTop: '-40px'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '50px', marginBottom: '50px'
          }}>
            <div>
              <div style={{ fontSize: '24px', fontWeight: '800', marginBottom: '16px', color: '#1C1C1E', letterSpacing: '-0.5px' }}>qaraa.asia</div>
              <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-start' }}>
                <img src={qaraaCrmLogo} alt="qaraa × qaraa.crm" style={{ height: '100px', width: 'auto' }} />
              </div>
              <div style={{ fontSize: '15px', color: '#636366', fontWeight: '500' }}>{t.logoSubtitle}</div>
            </div>
            <div>
              <div style={{ fontSize: '13px', fontWeight: '800', color: '#8E8E93', marginBottom: '20px', letterSpacing: '1.2px', textTransform: 'uppercase' }}>{t.footerNavigation}</div>
              {[{ name: t.footerAbout, path: '/about-us' }, { name: t.footerBonusCard, path: '/card-info' }, { name: t.footerVacancies, path: '/vacancies' }, { name: t.footerBusiness, path: '/business' }].map(l => (
                <div key={l.path} onClick={() => navigate(l.path)} style={{
                  fontSize: '15px', marginBottom: '12px', cursor: 'pointer', color: '#1C1C1E',
                  fontWeight: '500', transition: 'all 0.2s ease'
                }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#5856D6'; e.currentTarget.style.paddingLeft = '8px' }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = '#1C1C1E'; e.currentTarget.style.paddingLeft = '0' }}>
                  {l.name}
                </div>
              ))}
            </div>
            <div>
              <div style={{ fontSize: '13px', fontWeight: '800', color: '#8E8E93', marginBottom: '20px', letterSpacing: '1.2px', textTransform: 'uppercase' }}>{t.footerSocial}</div>
              {[
                { name: 'Instagram', url: 'https://www.instagram.com/qaraa.kz?igsh=cWw3cmlsNmJ0ZHRi' },
                { name: 'TikTok', url: 'https://www.tiktok.com/@qaraa.kz?_r=1&_t=ZM-91EaJ8tj6Do' },
                { name: 'Telegram', url: 'https://t.me/qaraa_kz' },
                { name: 'WhatsApp', url: 'https://wa.me/77778307588' }
              ].map(s => (
                <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer" style={{
                  display: 'block', fontSize: '15px', color: '#1C1C1E', fontWeight: '500',
                  textDecoration: 'none', marginBottom: '12px', transition: 'all 0.2s ease'
                }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#5856D6'; e.currentTarget.style.paddingLeft = '8px' }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = '#1C1C1E'; e.currentTarget.style.paddingLeft = '0' }}>
                  {s.name}
                </a>
              ))}
            </div>
            <div>
              <div style={{ fontSize: '13px', fontWeight: '800', color: '#8E8E93', marginBottom: '20px', letterSpacing: '1.2px', textTransform: 'uppercase' }}>{t.footerInfo}</div>
              <div style={{ fontSize: '15px', marginBottom: '12px', color: '#1C1C1E', fontWeight: '500' }}>+7 777 830 75 88</div>
              <div style={{ fontSize: '15px', color: '#636366', fontWeight: '500' }}>{t.footerCity}</div>
              <div style={{ fontSize: '15px', marginTop: '12px', color: '#636366', fontWeight: '500' }}>{t.footerAddress}</div>
            </div>
          </div>
          <div style={{
            marginTop: '80px', paddingTop: '40px',
            borderTop: '2px solid rgba(0, 0, 0, 0.06)',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            flexWrap: 'wrap', gap: '20px', fontSize: '15px', color: '#8E8E93', fontWeight: '600'
          }}>
            <div>{t.footerRights}</div>
            <div style={{ display: 'flex', gap: '24px' }}>
              <span onClick={() => navigate('/privacy')} style={{ cursor: 'pointer', transition: 'all 0.2s ease' }}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#5856D6' }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#8E8E93' }}>
                {t.footerPrivacy}
              </span>
              <span onClick={() => navigate('/terms')} style={{ cursor: 'pointer', transition: 'all 0.2s ease' }}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#5856D6' }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#8E8E93' }}>
                {t.footerTerms}
              </span>
            </div>
          </div>
        </div>
      </footer>
      {/* Mobile Styles */}
      <style>{`
        .mobile-break { display: none; }
        @media (max-width: 768px) {
          .mobile-break { display: inline; }
          .home-mobile-menu-button { display: flex !important; flex-direction: column !important; gap: 5px !important; }
          .home-header-button-login, .home-header-button-register { display: none !important; }
          .lang-text-label { display: none !important; }
          .lang-chevron { display: none !important; }
          .home-logo-subtitle.desktop-only-subtitle { display: none !important; }
          .mobile-only-subtitle { display: none !important; }
          .home-header-container { padding: 14px 16px !important; }
          .home-logo-container { gap: 10px !important; }
        }
      `}</style>
    </div>
  )
}
